import React, { useEffect, useState } from 'react';
import styles from '../../styles/ls-request/LsRequestSidebar.module.scss';
import { connect, useSelector } from 'react-redux';
import {
  createNewLsTask,
  updateLsTask,
  createSubtaskUpdate,
  deleteFullTaskAction,
  deleteSingleTaskUpdateAction,
} from '../../actions/lsRequestAction';
import {
  ArrowRepeatIcon,
  ArrowReturnLeftIcon,
  CheckmarkIcon,
  HourglassTopIcon,
  MyTasksIcon,
  PencilFillIcon,
  ThreeDotsVertical,
  TrashIcon,
} from '../../services/SvgLibrary.js';
import { Spinner } from 'reactstrap';

const LsSidebarTasks = props => {
  const { updateTargetLs, userList } = props;
  const [showForm, setShowForm] = useState(false);
  const initialFormData = {
    task_name: '',
    task_assigner: '',
    task_assignee: '',
    task_description: '',
    task_due_date: '',
    task_progress: 'Not Started',
    updates: [],
  };
  const [formData, setFormData] = useState(initialFormData);

  const [editTaskField, setEditTaskField] = useState(null);
  const [editTaskIndex, setEditTaskIndex] = useState(null);
  const [updateTaskData, setUpdateTaskData] = useState(
    updateTargetLs.ls_tasks || []
  );
  const [updateProgress, setUpdateProgress] = useState({});
  const [progressPriority, setProgressPriority] = useState({});
  const [openTasks, setOpenTasks] = useState({});

  const fields = [
    { name: 'task_name', type: 'text', placeholder: 'Task Name' },
    { name: 'task_description', type: 'textarea', placeholder: 'Description' },
    { name: 'task_due_date', type: 'date', placeholder: '' },
  ];

  useEffect(() => {
    if (updateTargetLs && updateTargetLs.hasOwnProperty('ls_tasks')) {
      setUpdateTaskData([...updateTargetLs.ls_tasks]);
      const priorityMapping = {
        'Not Started': 1,
        'In Progress': 2,
        'Completed': 3,
      };
      const newPriority = {};
      updateTargetLs.ls_tasks.forEach(task => {
        newPriority[task.id] = priorityMapping[task.task_progress] || 0;
      });
      setProgressPriority(newPriority);
    }
  }, [updateTargetLs]);

  const handleNewTaskClick = () => {
    setShowForm(true);
  };

  const toggleTaskUpdates = taskId => {
    setOpenTasks(prevOpenTasks => ({
      ...prevOpenTasks,
      [taskId]: !prevOpenTasks[taskId], // Toggle the open state for this specific task
    }));
  };

  const handleChangeForCreate = e => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  function clickingCreateTask(ls_request, taskData) {
    props.createNewLsTask(ls_request, taskData);
  }

  const handleSubmitCreate = e => {
    e.preventDefault();

    const { updates, ...dataWithoutUpdates } = formData;
    const finalData = { ...dataWithoutUpdates };

    finalData.task_assigner = props.userProfile.id;
    finalData.task_assignee = updateTargetLs.staff.id;

    setFormData(initialFormData);
    setShowForm(false);

    clickingCreateTask(updateTargetLs.id, finalData);
  };

  const handleDeleteFullTask = taskId => {
    props.deleteFullTaskAction({ fullTask: 'fullTask', taskId });
  };

  function clickingCreatingSubtaskUpdate(taskData) {
    props.createSubtaskUpdate(taskData);
  }

  const toggleEdit = (taskIndex, field) => {
    if (editTaskIndex !== null && editTaskIndex !== taskIndex) {
      // Prevent opening another field while currently editing one
      return;
    }
    setEditTaskField(prevField => (prevField === field ? null : field));
    setEditTaskIndex(prevIndex => (prevIndex === taskIndex ? null : taskIndex));
  };

  const handleMarkCompleted = taskIndex => {
    const updatedTasks = [...updateTaskData];
    updatedTasks[taskIndex] = {
      ...updatedTasks[taskIndex],
      task_progress: 'Completed',
    };
    clickingUpdateTask(updatedTasks[taskIndex]);
  };

  function clickingUpdateTask(taskData) {
    taskData['task_assignee'] = taskData.task_assignee?.id;
    taskData['task_assigner'] = taskData.task_assigner?.id;
    props.updateLsTask(taskData);
    setEditTaskField(null);
  }

  const handleFullTaskUpdate = (e, taskIndex, updatedKey, updateId) => {
    const newValue = e.target.value;

    const updatedTasks = [...updateTaskData];
    const taskToUpdate = { ...updatedTasks[taskIndex] };

    if (updatedKey === 'updates') {
      const updatedUpdates = taskToUpdate.updates.map(update => {
        if (update.id === updateId) {
          return { ...update, updated_progress: newValue };
        }
        return update;
      });

      taskToUpdate.updates = updatedUpdates;
    } else {
      taskToUpdate[updatedKey] = newValue;
    }

    updatedTasks[taskIndex] = taskToUpdate;

    clickingUpdateTask(taskToUpdate);
  };

  const EditableField = ({
    value,
    onSave,
    fieldType = 'text',
    options = [],
  }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [currentValue, setCurrentValue] = useState(value);

    const handleSave = () => {
      onSave(currentValue);
      setIsEditing(false);
    };

    const handleCancel = () => {
      setCurrentValue(value);
      setIsEditing(false);
    };

    const handleKeyDown = e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        handleSave();
      }
    };

    useEffect(() => {
      if (editTaskField === null) {
        setIsEditing(false);
      }
    }, [editTaskField]);

    return (
      <>
        {isEditing ? (
          <>
            <div className='input-group-sm input-group'>
              {fieldType === 'text' && (
                <input
                  className='form-control'
                  type='text'
                  value={currentValue}
                  onChange={e => setCurrentValue(e.target.value)}
                  onKeyDown={handleKeyDown}
                  autoFocus
                />
              )}
              {fieldType === 'date' && (
                <input
                  className='form-control'
                  type='date'
                  value={currentValue}
                  onChange={e => setCurrentValue(e.target.value)}
                  onKeyDown={handleKeyDown}
                  autoFocus
                />
              )}
              {fieldType === 'select' && (
                <select
                  className='form-control'
                  value={currentValue}
                  onChange={e => setCurrentValue(e.target.value)}
                  onBlur={handleSave}
                  autoFocus>
                  {options.map(option => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              )}
              {fieldType === 'textarea' && (
                <textarea
                  className='form-control'
                  value={currentValue}
                  onChange={e => setCurrentValue(e.target.value)}
                  onKeyDown={handleKeyDown}
                  autoFocus
                />
              )}
            </div>
            <div
              className='btn-group-sm'
              role='group'
            >
              <button type='button' className='btn btn-success' onClick={handleSave}>
                Save
              </button>&nbsp;
              <button type='button' className='btn btn-danger' onClick={handleCancel}>
                Cancel
              </button>
            </div>
          </>
        ) : (
          <div
            onClick={() => {
              setIsEditing(true);
              setEditTaskField(value);
            }}
            className={styles['editable-text-container']}
          >
            {value}&nbsp;
            <PencilFillIcon classNameProp={styles['edit-icon']} width={10} height={10}/>
          </div>
        )}
      </>
    );
  };

  // Creating a sub-task Update/Comment
  const handleProgressSubmit = (e, taskId) => {
    e.preventDefault();

    if (!updateProgress[taskId]) {
      alert('Please fill in the update progress.');
      return;
    }

    const newUpdate = {
      id: `temp-${new Date().getTime()}`, // Keep a temporary ID for immediate UI updates
      updated_progress: updateProgress[taskId],
      ls_task: taskId,
      updated_at: new Date().toISOString(),
      task_updater: { id: props.userProfile.id, full_name: props.userProfile.full_name },
      isNew: true, // Flag to indicate a new update
    };

    // Prepare the updates object
    const updates = [
      {
        updated_progress: updateProgress[taskId],
        ls_task: taskId,
        updated_at: new Date(),
        task_updater: props.userProfile.id,
      },
    ];
    setTimeout(() => {
      clickingCreatingSubtaskUpdate({ taskId, updates });
    }, 1500);

    // Add the new update with the isNew flag set
    setUpdateTaskData(prevTasks =>
      prevTasks.map(task =>
        task.id === taskId
          ? {
            ...task,
            updates: [newUpdate, ...task.updates],
          }
          : task
      )
    );

    // Automatically open the updates list for the task
    setOpenTasks(prevOpenTasks => ({
      ...prevOpenTasks,
      [taskId]: true,
    }));

    // Clear the update progress input field
    setUpdateProgress(prevProgress => ({
      ...prevProgress,
      [taskId]: '',
    }));
  };

  const handleProgressChange = (e, taskId) => {
    const { value } = e.target;
    setUpdateProgress(prevProgress => ({
      ...prevProgress,
      [taskId]: value,
    }));
  };

  const handleDeleteSingleTaskUpdate = (taskId, updateId) => {
    // Set the deleting flag to trigger the animation
    setUpdateTaskData(prevTasks =>
      prevTasks.map(task =>
        task.id === taskId
          ? {
            ...task,
            updates: task.updates.map(update =>
              update.id === updateId
                ? { ...update, isDeleting: true }
                : update
            ),
          }
          : task
      )
    );

    // Wait for the animation to complete before removing the update
    setTimeout(() => {
      // Dispatch Redux action to delete the update
      props.deleteSingleTaskUpdateAction({
        singleTaskUpdate: 'singleTaskUpdate',
        taskUpdateId: updateId,
        taskId: taskId,
      });
    }, 1500);
  };

  const buttonText =
    updateTaskData.length > 0 ? 'Add Task' : 'Create a new task';
  const [open, setOpen] = useState(false);

  return (
    <div className='container p-0'>
      {updateTaskData && updateTaskData.length === 0 && !showForm ? (
        <div
          className={`d-flex align-items-center flex-column justify-content-center p-5 rounded-3 w-100 ${styles['tasks-empty']}`}>
          <img src='../../img/no-results-found.svg' className='h-100 mb-4' />
          <button
            type='button'
            hidden={showForm}
            className='btn bg-white btn-light'
            onClick={handleNewTaskClick}>
            {buttonText}
          </button>
        </div>
      ) : (
        <div
          className='card mb-3'
          hidden={showForm}
          onClick={handleNewTaskClick}
          style={{'cursor': 'pointer'}}
        >
          <div className='card-body p-2'>
            <MyTasksIcon />
            <button
              className='ms-3 btn p-0'
              type='button'
            >
              {buttonText}
            </button>
          </div>
        </div>
      )}
      {/* START Main form to create new task */}
      {showForm &&
        (updateTargetLs.staff.full_name !== 'Unknown' ? (
          <div className='card w-100 h-auto mb-5'>
            <div className='card-header p-0 border-0'>
              <div className='card-header py-3 d-flex bg-light'>
                <span className='mb-0 fs-6'>New Task</span>
                <button
                  type='button'
                  className='btn-close ms-auto'
                  onClick={() => setShowForm(false)}
                  aria-label='Close'></button>
              </div>
            </div>
            <div className='card-body p-0'>
              <form onSubmit={handleSubmitCreate}>
                <div className='my-3 card-header bg-white border-0'>
                  {fields.map((field, index) => (
                    <div
                      key={field.name}
                      className={
                        index !== fields.length - 1
                          ? 'mb-3 input-group-sm input-group'
                          : 'input-group-sm input-group'
                      }>
                      {field.type === 'textarea' ? (
                        <textarea
                          className='form-control'
                          rows='5'
                          id={field.name}
                          name={field.name}
                          value={formData[field.name]}
                          onChange={handleChangeForCreate}
                          placeholder={field.placeholder}
                          aria-label={field.placeholder}
                          required
                        />
                      ) : (
                        <input
                          type={field.type}
                          className='form-control'
                          id={field.name}
                          name={field.name}
                          value={formData[field.name]}
                          onChange={handleChangeForCreate}
                          placeholder={field.placeholder}
                          aria-label={field.placeholder}
                          list={field.list ? 'user-list' : undefined}
                          required
                        />
                      )}

                      {field.list && (
                        <datalist id='user-list'>
                          {props.userList.map(user => (
                            <option key={user.id} value={user.full_name} />
                          ))}
                        </datalist>
                      )}
                    </div>
                  ))}
                </div>

                <div className='card-footer bg-light d-flex justify-content-end'>
                  <button
                    type='button'
                    className='btn btn-light me-2'
                    onClick={() => setShowForm(false)}>
                    Cancel
                  </button>
                  <button type='submit' className='btn btn-save'>
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        ) : (
          <div>
            <p>Please assign the LSR to a staff before creating a task!</p>
          </div>
        ))}
      {/* END Main form to create new task */}
      {updateTaskData
        .sort((a, b) =>
          progressPriority[a.id] < progressPriority[b.id] ? -1 : 1
        )
        .map((task, taskIndex) => {
          const isUserRelated =
            props.userProfile.full_name === task.task_assignee?.full_name ||
            props.userProfile.full_name === task.task_assigner?.full_name ||
            props.userProfile.permissions.lsRequest_api.approve_status_change;

          let taskProgressColor;
          let TaskIcon;
          switch (task.task_progress) {
            case 'In Progress':
              taskProgressColor = '#03a9f4';
              TaskIcon = ArrowRepeatIcon;
              break;
            case 'Completed':
              taskProgressColor = '#4caf50';
              TaskIcon = CheckmarkIcon;
              break;
            default:
              taskProgressColor = '#d93939';
              TaskIcon = HourglassTopIcon;
          }

          return (
            <div
              key={task.id}
              className='card p-3 position-relative mb-4 round-3'
              style={{
                fontSize: '0.8rem',
                backgroundColor: '#f6f7f9',
              }}>
              {isUserRelated ? (
                <>
                  <div
                    className={`d-flex ${task.task_progress === 'Completed'
                      ? 'justify-content-end'
                      : 'justify-content-between mb-3'
                      }`}
                    style={
                      task.task_progress === 'Completed'
                        ? { marginBottom: '-22px' }
                        : {}
                    }>
                    {task.task_progress !== 'Completed' && (
                      <button
                        className='btn btn-outline-secondary btn-sm'
                        style={{ fontSize: '0.8rem' }}
                        onClick={() => handleMarkCompleted(taskIndex)}>
                        <CheckmarkIcon width='14' classNameProp='me-2' />
                        Mark completed
                      </button>
                    )}
                    <button
                      className='btn p-0 text-align-end'
                      type='button'
                      id='dropdownMenuButton'
                      data-bs-toggle='dropdown'
                      aria-expanded='false'>
                      <ThreeDotsVertical />
                    </button>
                    <ul
                      className='dropdown-menu'
                      style={{ fontSize: '0.8rem' }}
                      aria-labelledby='dropdownMenuButton'>
                      {updateTaskData[taskIndex]?.updates &&
                        updateTaskData[taskIndex]?.updates.length > 0 && (
                          <li>
                            <a
                              className='dropdown-item'
                              href='#'
                              onClick={() => toggleTaskUpdates(task.id)}
                              aria-controls={`taskUpdates-${task.id}`}
                              aria-expanded={!!openTasks[task.id]}>
                              {openTasks[task.id]
                                ? 'Hide Task Updates'
                                : 'View Task Updates'}
                            </a>
                          </li>
                        )}
                      <li>
                        <a
                          className='dropdown-item'
                          href='#'
                          onClick={() => handleDeleteFullTask(task.id)}>
                          Delete
                        </a>
                      </li>
                    </ul>
                  </div>
                  <h3
                    className='fw-bold fs-5'
                    style={
                      task.task_progress === 'Completed' ? { width: '90%' } : {}
                    }>
                    <EditableField
                      value={task.task_name}
                      onSave={newValue =>
                        handleFullTaskUpdate(
                          { target: { value: newValue } },
                          taskIndex,
                          'task_name'
                        )
                      }
                    />
                  </h3>
                  <div className='container'>
                    <div className='row mb-2'>
                      <div className='col-3 p-0'>Description:</div>
                      <div className='col text-body-secondary'>
                        <div className='col text-body-secondary'>
                          <EditableField
                            value={task.task_description}
                            onSave={newValue =>
                              handleFullTaskUpdate(
                                { target: { value: newValue } },
                                taskIndex,
                                'task_description'
                              )
                            }
                            fieldType='textarea'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='row mb-2'>
                      <div className='col-3 p-0'>Assigner:</div>
                      <div className='col text-body-secondary'>
                        {task.task_assigner?.full_name}
                      </div>
                    </div>
                    <div className='row mb-2'>
                      <div className='col-3 p-0'>Assignee:</div>
                      <div className='col text-body-secondary'>
                        {task.task_assignee?.full_name}
                      </div>
                    </div>
                    <div className='row mb-2'>
                      <div className='col-3 p-0'>Due date:</div>
                      <div className='col text-body-secondary'>
                        <div className='col text-body-secondary'>
                          <EditableField
                            value={updateTaskData[taskIndex]?.task_due_date}
                            onSave={newValue =>
                              handleFullTaskUpdate(
                                { target: { value: newValue } },
                                taskIndex,
                                'task_due_date'
                              )
                            }
                            fieldType='date'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='row mb-2'>
                      <div className='col-3 p-0'>Progress:</div>
                      <div className='col text-body-secondary'>
                        {editTaskField === 'task_progress' &&
                          editTaskIndex === taskIndex ? (
                          <select
                            value={updateTaskData[taskIndex]?.task_progress}
                            onChange={e =>
                              handleFullTaskUpdate(
                                e,
                                taskIndex,
                                'task_progress'
                              )
                            }
                            className='badge rounded-pill'
                            style={{
                              border: '1px solid',
                              color: taskProgressColor,
                              fontSize: '0.7rem',
                              paddingBlock: '0.1rem',
                              backgroundColor: 'transparent',
                              cursor: 'pointer',
                            }}
                            autoFocus>
                            <option value='Not Started'>Not Started</option>
                            <option value='In Progress'>In Progress</option>
                            <option value='Completed'>Completed</option>
                          </select>
                        ) : (
                          <span
                            onClick={() =>
                              toggleEdit(taskIndex, 'task_progress')
                            }
                            className='badge rounded-pill'
                            style={{
                              border: '1px solid',
                              color: taskProgressColor,
                              fontSize: '0.7rem',
                              paddingBlock: '0.1rem',
                              cursor: 'pointer',
                            }}>
                            <TaskIcon
                              classNameProp='me-1 d-inline-flex align-items-center'
                              width='14'
                              fill={taskProgressColor}
                            />
                            {updateTaskData[taskIndex]?.task_progress}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className='border-top pt-3 mt-3'>
                    <form onSubmit={e => handleProgressSubmit(e, task.id)}>
                      <div className='input-group mb-3 border-1 shadow-sm rounded bg-white'>
                        <input
                          className='form-control shadow-none form-control-lg border-0'
                          style={{ fontSize: '0.9rem' }}
                          type='text'
                          value={updateProgress[task.id] || ''}
                          onChange={e => handleProgressChange(e, task.id)}
                          placeholder='Add your task update'
                        />
                        <button
                          className='btn border-0 bg-transparent'
                          type='submit'
                          id='button-addon2'>
                          <ArrowReturnLeftIcon />
                        </button>
                      </div>
                    </form>
                  </div>
                  <div
                    className={`collapse mt-3 ${openTasks[task.id] ? 'show' : ''
                      }`}
                    id={`taskUpdates-${task.id}`}>
                    {updateTaskData[taskIndex]?.updates &&
                      updateTaskData[taskIndex]?.updates.length > 0 && (
                        <ul className='list-group'>
                          {[...updateTaskData[taskIndex].updates]
                            .sort(
                              (a, b) =>
                                new Date(b.updated_at) - new Date(a.updated_at)
                            )
                            .map((update, updateIndex) => (
                              <li
                                key={update.id}
                                style={{ width: '90%', marginLeft: '9%' }}
                                className={`list-group-item border-end-0 border-top-0 border-bottom-0 d-flex flex-column position-relative justify-content-between align-items-start pb-3 mb-4 ${styles['task-update']
                                  } ${update.isNew ? 'new-update' : ''} ${update.isDeleting ? 'flash-delete' : ''
                                  }`}>
                                <span
                                  className={`d-flex align-items-center justify-content-center badge text-bg-secondary position-absolute top-0 start-0 translate-middle p-2 rounded-circle ${styles['user-initial']}`}>
                                  {update.task_updater?.full_name?.charAt(0) || 'U'}
                                </span>
                                <button
                                  onClick={() =>
                                    handleDeleteSingleTaskUpdate(
                                      task.id,
                                      update.id
                                    )
                                  }
                                  type='button'
                                  className='btn p-0 position-absolute top-0 start-100 translate-middle'
                                  aria-label='Close'>
                                  { update.isNew || update.isDeleting ? <Spinner color='secondary'/> : <TrashIcon width='15' /> }
                                </button>
                                <div
                                  className={`container d-flex flex-column mb-2 ${styles['update-entry-details']} update-entry-details`}>
                                  <span className='fw-bold'>
                                    {update.task_updater?.full_name || 'Unknown'}
                                  </span>
                                  <span>
                                    Updated at{' '}
                                    {new Date(update.updated_at).toLocaleString(
                                      'en-US',
                                      {
                                        year: 'numeric',
                                        month: '2-digit',
                                        day: '2-digit',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: false,
                                      }
                                    )}
                                  </span>
                                </div>
                                <EditableField
                                  value={update.updated_progress}
                                  onSave={newValue =>
                                    handleFullTaskUpdate(
                                      { target: { value: newValue } },
                                      taskIndex,
                                      'updates',
                                      update.id
                                    )
                                  }
                                />
                              </li>
                            ))}
                        </ul>
                      )}
                  </div>
                </>
              ) : (
                <div>
                  There is a task which is <strong>{task.task_progress}</strong>{' '}
                  and it is locked to assigner and assignee. For more info
                  contact <strong>{task.task_assignee.full_name}</strong>{' '}
                  or <strong>{task.task_assigner.full_name}</strong>
                </div>
              )}
            </div>
          );
        })}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    userProfile: state.userReducer.userProfile,
    userList: state.userReducer.userList,
    committeeList: state.userReducer.committees,
    updateTargetLs: state.lsRequestsReducer.updateTargetLs,
    updateTargetLsStatus: state.lsRequestsReducer.updateTargetLsStatus,
  };
};

const mapDispatchToProps = {
  createNewLsTask,
  updateLsTask,
  createSubtaskUpdate,
  deleteFullTaskAction,
  deleteSingleTaskUpdateAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(LsSidebarTasks);
